let treeHelper = require('../../helpers/tree');

const RUBRICS_TREE_BASE_PATH = ['order', 'rubrics', 'tree'];
const RUBRICS_ORIGINAL_DATA_PATH = ['order', 'originalParameters', 'rubrics'];

module.exports = {
    initTreeState (args, state) {
        treeHelper.initTreeUiState(state, RUBRICS_ORIGINAL_DATA_PATH, RUBRICS_TREE_BASE_PATH);
    },

    changeValue ({ path, value }, state) {
        treeHelper.changeTreeNodeValue(
            state,
            RUBRICS_ORIGINAL_DATA_PATH,
            RUBRICS_TREE_BASE_PATH,
            path,
            value);
    },

    setAll ({ value }, state) {
        treeHelper.setAllSelection(state, RUBRICS_ORIGINAL_DATA_PATH, RUBRICS_TREE_BASE_PATH, value);
    },

    isToggleFilterTypeOn(args, state, output) {
        let path = RUBRICS_TREE_BASE_PATH.concat('showFilterTreeInput');
        if(state.get(path)) {
            output.no();
        } else {
            output.yes();
        }
    },

    toggleFilterType (args, state) {
        let path = RUBRICS_TREE_BASE_PATH.concat('showFilterTreeInput');
        let value = state.get(path) || false;

        // показываем/прячем фильтр по списку
        state.set(path, !value);

        // прячем/показываем обычный фильтр
        state.set(RUBRICS_TREE_BASE_PATH.concat('hideFilter'), !value);
    },

    clearFilter (args, state) {
        treeHelper.clearFilter(state, RUBRICS_TREE_BASE_PATH, 'rubrics')
    }
};



// WEBPACK FOOTER //
// ./actions/custom-order/rubrics.js